/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const UNDERBRON: CommunityData = {
  code: "tradgarden",
  inviteCode: "underbron",
  name: "Under Bron",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/underbron`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#636363",
      counterColor: "#636363",
      logo: {
        src: "https://media.werz.at/community-assets/UNDERBRON/web-logo-v3.png",
        styles: "w-[160px] h-auto",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "bg-[#000000] border-r-2 border-[#636363]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['ArialRegular']",
      nonMemberBg: "",
      nonMemberBgColor: "#000000",
      primaryButton:
        "bg-[#636363] border-2 border-transparent px-[18px] py-[18px] !text-[#ffffff] font-['ArialRegular'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#636363",
      sideBarSeparator: "border-r-[1px] border-[#636363]",
      separator: "#636363",
      item: "text-[#636363] font-['ArialBold'] text-[18px] uppercase text-center bg-[#000000] text-center border-b border-[#636363] !pl-0 !py-3",
      itemSelected: "!text-[#ffffff]",
    },
    communityLanding: {
      container: "bg-[#000000] border-2 border-[#636363] !pb-8 overflow-hidden",
      titles: "text-[#ffffff] font-['ArialBold'] text-[32px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#636363] font-['ArialRegular'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-[2px] border-[#636363]",
        sectionTitle:
          "text-[#ffffff] font-['ArialBold'] text-[32px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-[#636363]",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#636363] font-['ArialBold'] text-[16px] text-left leading-[110%]",
          subtitle: "text-[#636363] font-['ArialRegular'] text-[12px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b-[2px] border-[#636363]",
        sectionTitle:
          "text-[#ffffff] font-['ArialBold'] text-[32px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:!mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 sm:!h-[128px] relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-[#636363]",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "text-[#636363] font-['ArialBold'] sm:text-[16px] text-left text-[16px] leading-[110%]",
          subtitle: "text-[#636363] font-['ArialRegular'] text-[12px] text-left",
          location: "text-[#636363] font-['ArialRegular'] text-[12px] text-left",
          date: "text-[#636363] font-['ArialRegular'] text-[12px] text-left",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['ArialBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#636363] font-['ArialRegular'] text-[16px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['ArialBold'] text-[24px] text-left leading-[110%] !mb-4 sm:!mb-4",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] border-2 border-[#636363] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#636363] font-['ArialBold'] text-[32px] text-left leading-[110%]",
        subtitle: "text-[#636363] font-['ArialRegular'] text-[14px] text-left mb-4 mt-2",
        button:
          "bg-[#636363] border-2 border-transparent px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['ArialRegular'] text-[16px] text-left",
        questions: "text-[#636363] text-[14px] text-left",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-[2px] border-[#636363] border-t-[2px]",
        header: "text-[#636363] font-['ArialBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#636363] font-['ArialRegular'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b-[2px] border-[#636363]",
        header: "text-[#636363] font-['ArialBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#636363] font-['ArialRegular'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] border-[2px] border-[#636363]",
        mapPinColor: "#636363",
        mapStrokeColor: "#636363",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#636363] font-['ArialBold'] text-[24px] text-left leading-[110%]",
        text: "text-[#636363] font-['ArialRegular'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['ArialBold'] text-[32px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#000000] border-2 border-[#636363] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "!bg-[#000000] border-2 border-[#636363] px-4 py-3 text-[#636363] font-['ArialBold'] text-[14px] text-left !w-fit uppercase",
        },
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 !border-b !border-[#636363] mb-4 bg-[#000000]",
          media: "!hidden",
          name: "text-[#636363] font-['ArialBold'] text-[16px] text-left leading-[110%]",
          description:
            "text-[#636363] font-['ArialRegular'] text-[14px] text-left leading-[120%] !mt-1",
          price: "text-[#636363] font-['ArialBold'] text-[16px] text-left leading-[110%] !mt-1",
          quantity: "text-[#636363] font-['ArialBold'] text-[14px] text-left mt-1",
          status: "text-[#636363] font-['ArialBold'] text-[16px] text-left leading-[110%]",
          counterContainer: "bg-[#000000] border-2 border-[#636363] px-4 py-3 gap-x-4 !w-fit !h-10",
          button:
            "!bg-[#000000] border-2 border-[#636363] px-4 py-3 text-[#636363] font-['ArialBold'] text-[14px] text-left !w-fit uppercase",
          plusMinusColor: "#636363",
        },
      },
    },
  },
}

export default UNDERBRON
